// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationDashboardRevisionId = (z.number());
export const fermentationDashboardRevision = z.object({
    id: fermentationDashboardRevisionId,
    dashboard_id: z.number(),
    revision: z.number(),
    layout: z.unknown(),
    restored_from_revision_id: fermentationDashboardRevisionId.nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
});
export const fermentationDashboardRevisionInitializer = z.object({
    id: fermentationDashboardRevisionId.optional(),
    dashboard_id: z.number(),
    revision: z.number(),
    layout: z.unknown(),
    restored_from_revision_id: fermentationDashboardRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const fermentationDashboardRevisionMutator = z.object({
    id: fermentationDashboardRevisionId.optional(),
    dashboard_id: z.number().optional(),
    revision: z.number().optional(),
    layout: z.unknown().optional(),
    restored_from_revision_id: fermentationDashboardRevisionId.optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationDashboardRevision.js.map